import { SectorModel ,ExcelPredictModel} from './sector.model';

import { DBConnectorService } from './test.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class PredictService {

  InstaResult:any ={};
  result:any = {};
  public showContraCheckBox : boolean;

  constructor(private http: HttpClient, private dbconnectorservice: DBConnectorService) {
  }

  Insta(Description) {
    var url = '/api/InstantPredict/InstantPredict1'
    return this.http.post<any>(url, Description) //add the json file for prediction
  }
  setInsta(result: any){
    this.InstaResult = result
  }
  excelPredictModel = new ExcelPredictModel;
  Predict(Sector_data: SectorModel,IsContraEnabled) {
    var url = '/api/PredictUsingExcel/PredictExcel';
    Sector_data.User = this.dbconnectorservice.username;
    this.excelPredictModel.sectorModel=Sector_data ;
    this.excelPredictModel.IsContraEnabled=IsContraEnabled;

    return this.http.post<any>(url, this.excelPredictModel) //add the json file for prediction
  }

  statusCheck(Data) {
    var url = '/api/PredictUsingExcel/PredictStatus'
    return this.http.post<any>(url, Data) //add the json file
  }

  contraStatusCheck(sectorModelData){
    this.invokeContraStatusCheck(sectorModelData).subscribe(data => {
      this.showContraCheckBox = data;
    })
  }

  invokeContraStatusCheck(sectorModelData) {
    var url = '/api/PredictUsingExcel/ContraStatusCheck'
    let headers = new Headers();
    headers.append('UserName', this.dbconnectorservice.username);
    headers.append('IpAddress', this.dbconnectorservice.ipaddress);
    let options = {
      headers: new HttpHeaders({
        'UserName': this.dbconnectorservice.username,
        'IpAddress': this.dbconnectorservice.ipaddress
      })
    }
    
    return this.http.post<any>(url, sectorModelData) //add the json file
  }

  cancelPredict(Data) {
    var url = '/api/PredictUsingExcel/CancelPredict'
    return this.http.post<any>(url, Data) //add the json file
  }
  
}
